export class TransportCreationProfileSight {

  id: number;
  name: string;

  constructor(profile?: any) {
      if (profile != null) {
          this.id = profile.id;
          this.name = profile.name;
      }
  }
}

export class EntranceSight {

    id: number;
    name: string;

    constructor(entrance?: any) {
        if (entrance != null) {
            this.id = entrance.id;
            this.name = entrance.name;
        }
    }
}